module.exports = __webpack_public_path__ + "static/img/HUMBER.f9d6495.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/HUMBER.jpg
// module id = XPuH
// module chunks = 0